export const IL_COUNTIES: string[] = [
  'Adams',
  'Alexander',
  'Bond',
  'Boone',
  'Brown',
  'Bureau',
  'Calhoun',
  'Carroll',
  'Cass',
  'Champaign',
  'Christian',
  'Clark',
  'Clay',
  'Clinton',
  'Coles',
  'Cook',
  'Crawford',
  'Cumberland',
  'DeKalb',
  'De Witt',
  'Douglas',
  'DuPage',
  'Edgar',
  'Edwards',
  'Effingham',
  'Fayette',
  'Ford',
  'Franklin',
  'Fulton',
  'Gallatin',
  'Greene',
  'Grundy',
  'Hamilton',
  'Hancock',
  'Hardin',
  'Henderson',
  'Henry',
  'Iroquois',
  'Jackson',
  'Jasper',
  'Jefferson',
  'Jersey',
  'Jo Daviess',
  'Johnson',
  'Kane',
  'Kankakee',
  'Kendall',
  'Knox',
  'Lake',
  'LaSalle',
  'Lawrence',
  'Lee',
  'Livingston',
  'Logan',
  'Macon',
  'Macoupin',
  'Madison',
  'Marion',
  'Marshall',
  'Mason',
  'Massac',
  'McDonough',
  'McHenry',
  'McLean',
  'Menard',
  'Mercer',
  'Monroe',
  'Montgomery',
  'Morgan',
  'Moultrie',
  'Ogle',
  'Peoria',
  'Perry',
  'Piatt',
  'Pike',
  'Pope',
  'Pulaski',
  'Putnam',
  'Randolph',
  'Richland',
  'Rock Island',
  'St. Clair',
  'Saline',
  'Sangamon',
  'Schuyler',
  'Scott',
  'Shelby',
  'Stark',
  'Stephenson',
  'Tazewell',
  'Union',
  'Vermilion',
  'Wabash',
  'Warren',
  'Washington',
  'Wayne',
  'White',
  'Whiteside',
  'Will',
  'Williamson',
  'Winnebago',
  'Woodford',
]
